export default __webpack_public_path__ + "static/8_15-c50ef978dfb462b82cf82314a20f261c.png";